export default __webpack_public_path__ + "static/media/AndriyK295.6e80da32.jpg";